import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { BaseRules, TextValues } from './rhode-island.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
@Component({
  selector: 'app-rhode-island',
  templateUrl: './rhode-island.component.html',
  styleUrls: ['./rhode-island.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
  ],
})
export class RhodeIslandComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('rhode-island', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('rhode-island', null);
    }
  }
}
